import React, { forwardRef, useMemo } from "react";
import { FieldTypes } from "utils/formUtils";
import { urlRegexValidator } from "utils/formUtils";
import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import OligoMappingForm from "./OligoMappingForm";

function OligoCredentialsForm(props, ref) {
  const fields = useMemo(() => {
    return [
      {
        name: "apiEndpoint",
        label: "API EndPoint",
        required: true,
        rules: [urlRegexValidator],
      },
      {
        name: "clientId",
        label: "Client ID",
        required: true,
      },
      {
        name: "clientSecret",
        label: "Client Secret",
        required: true,
        type: FieldTypes.PASSWORD,
      },
      {
        name: "realm",
        label: "Realm",
        required: true,
      }
    ];
  }, []);

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={OligoMappingForm}
      initialValue={{ apiEndpoint: "https://app.oligo.security" }}
    />
  );
}

export default forwardRef(OligoCredentialsForm);
